import { io } from "socket.io-client";
//import { apiClient } from "./apiClient";

let socket;

export const connectSocket = (token) => {
  socket = io("https://cico-time.com", {
    path:"/api/socket.io",
    auth: {token},
    autoConnect: false
  });

  socket.connect();

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};
